const textDefaults = {
	EN: {
		selectLanguageTitle: 'Select your language',
		selectLanguageDescription: 'Please select the language you want to use for the e-learning.',
		languageLabel: 'Language',
		continueButton: 'Continue',
		continueTitle: 'Continue your e-learning',
		continueDescription: 'You have already started this e-learning. Click the button below to continue where you left off.',
		continueToPlayitButton: 'Continue to Playit',
	},
	NL: {
		selectLanguageTitle: 'Selecteer je taal',
		selectLanguageDescription: 'Selecteer de taal die je wilt gebruiken voor de e-learning.',
		languageLabel: 'Taal',
		continueButton: 'Doorgaan',
		continueTitle: 'Ga verder met je e-learning',
		continueDescription: 'Je bent al begonnen met deze e-learning. Klik op de knop hieronder om verder te gaan waar je gebleven was.',
		continueToPlayitButton: 'Verder naar Playit',
	},
	DE: {
		selectLanguageTitle: 'Wähle deine Sprache',
		selectLanguageDescription: 'Bitte wähle die Sprache, die du für das E-Learning verwenden möchtest.',
		languageLabel: 'Sprache',
		continueButton: 'Weiter',
		continueTitle: 'Setze dein E-Learning fort',
		continueDescription: 'Du hast dieses E-Learning bereits begonnen. Klicke auf die Schaltfläche unten, um dort fortzufahren, wo du aufgehört hast.',
		continueToPlayitButton: 'Weiter zu Playit',
	},
	FR: {
		selectLanguageTitle: 'Sélectionnez votre langue',
		selectLanguageDescription: 'Veuillez sélectionner la langue que vous souhaitez utiliser pour l\'e-learning.',
		languageLabel: 'Langue',
		continueButton: 'Continuer',
		continueTitle: 'Continuez votre e-learning',
		continueDescription: 'Vous avez déjà commencé cet e-learning. Cliquez sur le bouton ci-dessous pour reprendre là où vous vous êtes arrêté.',
		continueToPlayitButton: 'Continuer vers Playit',
	},
	HR: {
		selectLanguageTitle: 'Odaberite svoj jezik',
		selectLanguageDescription: 'Molimo odaberite jezik koji želite koristiti za e-učenje.',
		languageLabel: 'Jezik',
		continueButton: 'Nastavi',
		continueTitle: 'Nastavite svoje e-učenje',
		continueDescription: 'Već ste započeli ovo e-učenje. Kliknite gumb ispod da nastavite gdje ste stali.',
		continueToPlayitButton: 'Nastavi na Playit',
	},
	LT: {
		selectLanguageTitle: 'Pasirinkite savo kalbą',
		selectLanguageDescription: 'Pasirinkite kalbą, kurią norite naudoti e. mokymuisi.',
		languageLabel: 'Kalba',
		continueButton: 'Tęsti',
		continueTitle: 'Tęskite savo e. mokymąsi',
		continueDescription: 'Jūs jau pradėjote šį e. mokymąsi. Spustelėkite žemiau esantį mygtuką, kad tęstumėte nuo tos vietos, kur baigėte.',
		continueToPlayitButton: 'Tęsti į Playit',
	},
	PL: {
		selectLanguageTitle: 'Wybierz swój język',
		selectLanguageDescription: 'Wybierz język, którego chcesz używać w e-learningu.',
		languageLabel: 'Język',
		continueButton: 'Kontynuuj',
		continueTitle: 'Kontynuuj swój e-learning',
		continueDescription: 'Już rozpocząłeś ten e-learning. Kliknij przycisk poniżej, aby kontynuować od miejsca, w którym skończyłeś.',
		continueToPlayitButton: 'Kontynuuj do Playit',
	},
	PT: {
		selectLanguageTitle: 'Selecione o seu idioma',
		selectLanguageDescription: 'Por favor, selecione o idioma que deseja usar para o e-learning.',
		languageLabel: 'Idioma',
		continueButton: 'Continuar',
		continueTitle: 'Continue o seu e-learning',
		continueDescription: 'Você já iniciou este e-learning. Clique no botão abaixo para continuar de onde parou.',
		continueToPlayitButton: 'Continuar para Playit',
	},
	RO: {
		selectLanguageTitle: 'Selectați limba dvs.',
		selectLanguageDescription: 'Vă rugăm să selectați limba pe care doriți să o utilizați pentru e-learning.',
		languageLabel: 'Limbă',
		continueButton: 'Continuă',
		continueTitle: 'Continuați e-learning-ul',
		continueDescription: 'Ați început deja acest e-learning. Faceți clic pe butonul de mai jos pentru a continua de unde ați rămas.',
		continueToPlayitButton: 'Continuă la Playit',
	},
	SK: {
		selectLanguageTitle: 'Vyberte si jazyk',
		selectLanguageDescription: 'Vyberte jazyk, ktorý chcete použiť pre e-learning.',
		languageLabel: 'Jazyk',
		continueButton: 'Pokračovať',
		continueTitle: 'Pokračujte vo svojom e-learningu',
		continueDescription: 'Tento e-learning ste už začali. Kliknutím na tlačidlo nižšie pokračujte tam, kde ste skončili.',
		continueToPlayitButton: 'Pokračovať na Playit',
	},
};

export function getTextDefaults(lang) {
	if (!lang) return textDefaults['EN'];
	// Normalize: "nl" -> "NL", "hr-HR" -> "HR", "lt-LT" -> "LT", "sk-SK" -> "SK"
	const normalizedLang = lang.toUpperCase().split('-')[0];
	return textDefaults[normalizedLang] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}
